/**
 * Ciao Bella — product description spec accordions.
 *
 * Furniture descriptions carry long spec lists (Dimenzije, Materijali, Održavanje…)
 * written as headings inside the product description rich text. This progressively
 * enhances those headings into native <details> accordions so the buy area stays
 * compact, without requiring the merchant to restructure their content.
 *
 * Native <details>/<summary> keeps it keyboard accessible with no ARIA needed.
 * If this script fails to run, the description simply renders as normal prose.
 */
(function () {
  var HEADING = /^H[234]$/;

  function enhance(block) {
    if (block.dataset.cbAccordion) return;

    // Only convert when there are at least two headings — otherwise it's prose.
    var headings = block.querySelectorAll(':scope > h2, :scope > h3, :scope > h4');
    if (headings.length < 2) return;

    block.dataset.cbAccordion = 'true';
    block.classList.add('cb-spec-accordions');

    var nodes = Array.prototype.slice.call(block.children);
    var body = null;

    nodes.forEach(function (node) {
      // Dividers between sections duplicate the accordion borders: drop them,
      // and treat each one as the end of the current section so trailing notes
      // (e.g. "Napomena") stay visible instead of hiding inside the last panel.
      if (node.tagName === 'HR') {
        node.remove();
        body = null;
        return;
      }

      if (HEADING.test(node.tagName)) {
        var details = document.createElement('details');
        details.className = 'cb-spec';

        var summary = document.createElement('summary');
        summary.className = 'cb-spec__summary';
        summary.textContent = node.textContent.trim();
        details.appendChild(summary);

        body = document.createElement('div');
        body.className = 'cb-spec__body';
        details.appendChild(body);

        block.insertBefore(details, node);
        node.remove();
      } else if (body) {
        // Content following a heading belongs to that section.
        body.appendChild(node);
      }
      // Content before the first heading is left untouched as intro copy.
    });
  }

  function init() {
    if (!/\/products\//.test(window.location.pathname)) return;
    var scope = document.querySelector('main') || document.body;
    scope.querySelectorAll('.rte').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
